import { isEmpty, isNil, keys } from 'ramda';
export const EXTENTIONS_MAP = {
  doc: ['pdf', 'ppt', 'txt', 'doc', 'pptx', 'docx', 'xls', 'xlsx', 'oform', 'docxf', 'csv'],
  img: ['jpg', 'jpeg', 'png', 'pdf', 'tiff', 'swf', 'gif', 'bmp', 'webp'],
  media: ['flv', 'rmvb', 'mp4', 'mvb', 'avi', 'mov', 'wam', 'mp3', 'mepg', '3gp', 'vob']
};
function getFileExtension(file) {
  const parts = file.name.split('.');
  return parts.length > 1 ? parts.pop()?.toLowerCase() : '';
}
export function vaildMaxSize(file, config) {
  const maxSize = config.attachmentConfig?.sizeLimit || 50;
  const validSize = file.size / 1024 / 1024 < maxSize;
  if (!validSize) {
    return {
      status: 'error',
      maxSize
    };
  }
  return {
    status: 'ok'
  };
}
export function vaildMaxCount(count, config) {
  const maxCount = config.attachmentConfig?.countLimit || 10;
  const validCount = count <= maxCount;
  if (!validCount) {
    return {
      status: 'error',
      maxCount
    };
  }
  return {
    status: 'ok'
  };
}
export function vaildExt(file, config) {
  let validExt = isNil(config.attachmentConfig?.allowUploadExtensions) || isEmpty(config.attachmentConfig?.allowUploadExtensions);
  let ext = '';
  if (!validExt) {
    const allowUploadExtensions = (config.attachmentConfig?.allowUploadExtensions || keys(EXTENTIONS_MAP)).map(i => EXTENTIONS_MAP[i]).flat();
    ext = getFileExtension(file);
    validExt = allowUploadExtensions.includes(ext);
  }
  if (!validExt) {
    return {
      status: 'error',
      ext
    };
  }
  return {
    status: 'ok'
  };
}